(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["da-product-detail"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-da-product-section]').forEach(function (root) {
    var form = root.querySelector('.da-product-form');
    if (!form) return;

    var mainImage = root.querySelector('[data-da-main-image]');
    root.querySelectorAll('[data-da-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        root.querySelectorAll('[data-da-thumb]').forEach(function (b) {
          b.classList.remove('da-on');
        });
        btn.classList.add('da-on');
        if (mainImage) mainImage.src = btn.getAttribute('data-full');
      });
    });

    var qtyInput = form.querySelector('[data-da-qty-input]');
    var minusBtn = form.querySelector('[data-da-qty-minus]');
    var plusBtn = form.querySelector('[data-da-qty-plus]');
    if (minusBtn && qtyInput) {
      minusBtn.addEventListener('click', function () {
        qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
      });
    }
    if (plusBtn && qtyInput) {
      plusBtn.addEventListener('click', function () {
        qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1;
      });
    }

    var variantIdField = form.querySelector('[data-da-variant-id]');
    var priceEl = form.querySelector('[data-da-price]');
    var unitPriceEl = form.querySelector('[data-da-unit-price]');
    var stockEl = form.querySelector('[data-da-stock]');
    var atcBtn = form.querySelector('[data-da-atc]');
    form.querySelectorAll('[data-da-variant-radio]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (variantIdField) variantIdField.value = radio.getAttribute('data-variant-id');
        var available = radio.getAttribute('data-available') === 'true';
        if (priceEl) priceEl.textContent = radio.getAttribute('data-price');
        if (unitPriceEl) {
          var unitPrice = radio.getAttribute('data-unit-price') || '';
          unitPriceEl.textContent = unitPrice;
          unitPriceEl.style.display = unitPrice ? 'block' : 'none';
        }
        if (atcBtn) atcBtn.disabled = !available;
        if (stockEl) stockEl.classList.toggle('da-stock--out', !available);
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
